import React from "react";

import NoResults from "../../../common/NoResults";
import ActionBtn from "../../../common/management/ActionBtn";

import { SonicDBEntryData } from "../../../common/classes/SonicDBEntry";
import { SonicUserData } from "../../../common/classes/SonicUser";

import styles from "../../management/db-list/DBList.module.scss";

import { checkForJikeiRoles } from "../../../utils/GeneralUtils";

type ListProps = {
  persons: Array<SonicDBEntryData>;
  owners: Array<SonicUserData>;
  isStudent: boolean;
};

const ReleasePersonList: React.FC<ListProps> = ({
  persons,
  owners,
  isStudent,
}) => {
  if (persons.length === 0) return <NoResults />;

  return (
    <div className={styles["f-dbList"]}>
      <div
        className={`${styles["f-dbList__category"]} ${styles["head"]} ${styles["release"]}`}
      >
        <div>{isStudent === true ? "学生氏名" : "会員氏名"}</div>
        <div>プロフィール名</div>
        <div>メールアドレス</div>
        {isStudent === true ? <div>学校名</div> : null}
        <div>アクション</div>
      </div>
      {persons.map((person, i) => (
        <div
          className={`${styles["f-dbList__category"]} ${styles["body"]} ${styles["release"]}`}
          key={i}
        >
          <div>
            {checkForJikeiRoles(owners?.[i]?.roles) ? (
              <span className={styles["userType"]}>{"滋"}</span>
            ) : null}
            {isStudent && owners?.[i]?.meta?.full_name
              ? owners?.[i]?.meta?.full_name
              : owners?.[i]?.meta?.name}
          </div>
          <div>{person.name}</div>
          <div>{owners?.[i]?.meta?.email}</div>
          {isStudent === true ? <div>{person.school?.name}</div> : null}
          <div className={styles["f-dbList__category-body__action"]}>
            <ActionBtn
              label="対応する"
              icon={["fal", "edit"]}
              link={
                isStudent === true
                  ? `/jikei/release/person/${person.id}`
                  : `/admin/release/person/${person.id}`
              }
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReleasePersonList;
